import stringToNumber from "src/utils/stringToNumber";
import yup from "src/utils/yup/extensionMethods";

const indicatorFormSchema = (translate:Function,language:string) => yup.object().shape({
	indicator: iqtbc001Schema(translate,language),
	goal:iqtbc002Schema(translate,language),
	competitiveness:iqtbc002Schema(translate,language)
		.when("$useCompetitiveness",(useCompetitiveness,schema) => useCompetitiveness ? schema.required("Insira os dados de competitividade"):schema.nullable().default(null)),
	compromise:iqtbc002Schema(translate,language)
		.when("$useCompromise",(useCompromise,schema) => useCompromise ? schema.required("Insira os dados de compromisso"):schema.nullable().default(null)),
	fields:yup.array()
		.of(iqtbc002Schema(translate,language,false))
		.min(1,translate("Ao menos um campo deve ser informado"))
		.required(translate("Ao menos um campo deve ser informado"))
		.unique(translate("Campos não podem ser repetidos"), (a: any) => a.iqc002Iqb001Id),
	metrics:yup.array()
		.of(iqtbc004Schema(translate,language))
		.min(1,translate("Ao menos uma faixa deve ser informada"))
		.required(translate("Ao menos uma faixa deve ser informada")),
	permissions:yup.array()
		.of(iqtbc005Schema(translate,language))
		.min(1,translate("Ao menos uma permissão deve ser informada"))
		.required(translate("Ao menos uma permissão deve ser informada"))
		.unique(translate("Usuários não podem ser repetidos"), (a: any) => a.iqc005Efa005Id, (a: any) => !a.iqc005Efa004Id)
		.unique(translate("Grupo de usuários não podem ser repetidos"), (a: any) => a.iqc005Efa004Id, (a: any) => !a.iqc005Efa005Id)
});

const iqtbc001Schema = (translate:Function,language:string) => yup.object().shape({
	iqc001Codigo : yup.string()
		.when("$isAdd",(isAdd,schema) => !isAdd ? schema.required(translate("O código é obrigatório")):schema),
	iqc001Descricao: yup.string()
		.required(translate("Descrição é requerida")),
	iqc001Qtdeperant: yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.required(translate("Campo é obrigatório"))
		.typeError(translate("Campo está com valor incorreto")),
	iqc001Iqb003Id:yup.number()
		.transform((value,originalValue) => typeof originalValue !== "string" ? value : stringToNumber(originalValue,language))
		.required(translate("O tipo de período é obrigatório"))
		.typeError(translate("O tipo de período está com valor incorreto")),
	iqc001Efa005Id:yup.number()
		.required(translate("O responsável é obrigatório")),
	iqc001DecimaisPainel: yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.required(translate("Campo é obrigatório"))
		.typeError(translate("Campo está com valor incorreto"))
});

const iqtbc002Schema = (translate:Function,language:string,isGoal:boolean=true) => yup.object().shape({
	iqc002Iqb001Id:yup.string()
		.required(translate("Campo é requerido")),
	iqc002Metadefault:yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.typeError(translate("Campo está com valor incorreto"))
		.when("id",(_,schema) => isGoal ? schema.required("Meta padrão é obrigatoria"):schema.nullable()),
	iqc002Utilizarcamposbase:yup.boolean(),
	iqc002Dividendo:yup.string()
		.when("iqc002Utilizarcamposbase",(utilizacampo,schema) => utilizacampo ? schema.required("Campo é requerido"):schema.nullable()),
	iqc002Divisor:yup.string()
		.when("iqc002Utilizarcamposbase",(utilizacampo,schema) => utilizacampo ? schema.required("Campo é requerido"):schema.nullable())
});

const iqtbc004Schema = (translate: Function,language:string) => yup.object().shape({
	iqc004Cor: yup.string().required(translate("Cor da faixa é requerida")),
	iqc004Valorini: yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.required(translate("Valor inicial a faixa é requerida"))
		.typeError(translate("Valor inicial está incorreto")),
	iqc004Valorfim:yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue!==0 && originalValue!=="0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.required(translate("Valor final da faixa é requerida"))
		.typeError(translate("Valor final está incorreto"))
		.when("iqc004Valorini",(initiaValue,schema) => initiaValue ? schema.min(initiaValue,translate("Valor inicial não pode ser menor que o final")):schema)
});

const iqtbc005Schema = (translate: Function,language:string) => yup.object().shape({
	iqc005Efa004Id: yup.string()
		.transform((value,originalValue) => originalValue ? value : "")
		.when("iqc005Efa005Id",(userId,schema) => !userId ? schema.required(translate("Grupo de usuário é requerido")):schema.nullable()),
	iqc005Efa005Id: yup.string()
		.transform((value,originalValue) => originalValue ? value : "")
		.when("iqc005Efa004Id",(groupId,schema) => !groupId ? schema.required(translate("Usuário é requerido")):schema.nullable()),
	iqc005Permissao:yup.number()
		.transform((value,originalValue) => {
			if(!originalValue && originalValue !== 0 && originalValue !== "0")
				return null;
			return typeof originalValue !== "string" ? value : stringToNumber(originalValue,language);
		})
		.required(translate("Opção de permissão é requerida"))
		.typeError(translate("Opção de permissão está incorreta"))
		.oneOf([0,1,2,3,4,5], translate("Opção invalida"))
},[["iqc005Efa005Id","iqc005Efa004Id"]]);

export default indicatorFormSchema;
